import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api_get } from "api/utils";

export default function RequestEmailRender() {
    const { requestKey } = useParams();
    const [html, setHtml] = useState('');

    useEffect(() => {
        api_get(`/request/email-render?request=${requestKey}`)
            .then(async (res) => {
                const content = await res.json();
                setHtml(content.html_content);
                console.log(html);
            });
    }, [requestKey]);


    return (
		<div dangerouslySetInnerHTML={{__html: html}} />
    );
}
